import useBuyPsbt, { BuyLoadingStage } from '../../../hooks/useBuyPsbt'
import { IOrdItem } from '../../../lib/msigner'
import { OrderDetail } from '../../../utils/http/Services/market'
import { useState } from 'react'
import styled from 'styled-components'
import { commonStyles } from '../../../utils/commonStyles'
import { BtcIcon } from '../../views/common/Bitcoin'
import { formatFloat, formatSat } from '../../../utils'
import FeeSelector from '../../views/common/FeeSelector'
import { XButton } from '../../views/common/XButton'
import { OrderStatus } from '../../../utils/type'
import Loading from '../../views/common/Loading'
import TxHashLink from '../../views/common/TxHashLink'
import { useWallet } from '../../context/WalletContext'
import { calculateTxBytesFee } from '../../../utils/BuyerSigner'

export default function ListedPanel(props: { nftItem: IOrdItem; order?: OrderDetail | null; onBuyed?: () => void }) {
  const price = props.order?.price || 0
  const takerFeeBp = props.order?.taker_fee || 0
  const makerFeeBp = props.order?.maker_fee || 0
  const takerFee = (price * takerFeeBp) / 10000
  const [fee, setFee] = useState(0)
  const { account, connected, active } = useWallet()
  const payAmount = price + takerFee
  const { buyPsbt, loading, loadingTx, prepared } = useBuyPsbt(props.nftItem, price, takerFeeBp, makerFeeBp, fee)
  const networkFee = calculateTxBytesFee(5, 6, fee)
  const showTxLoading =
    loading === BuyLoadingStage.WaitingConfirm ||
    (!!props.order?.padding_tx_hash && props.order?.status === OrderStatus.Pending)
  const loadingHash = loadingTx || props.order?.padding_tx_hash || ''
  const showConnect = !connected
  const isOwner = props.nftItem.owner === account
  const showBuy =
    loading < BuyLoadingStage.WaitingConfirm &&
    connected &&
    props.nftItem.listed &&
    !isOwner &&
    !props.order?.padding_tx_hash
  return (
    <SalePanelWrapper>
      <InfoBox>
        <span className={'label'}>Listing Price:</span>
        <span className={'value'}>
          <BtcIcon right={13} top={3} /> {formatFloat(formatSat(price))} BTC
        </span>
      </InfoBox>
      {/*{takerFeeBp > 0 && (*/}
      <InfoBox>
        <span className={'label'}>Taker Fee({takerFeeBp / 100}%):</span>
        <span className={'value'}>
          <BtcIcon right={13} top={3} /> {formatFloat(formatSat(takerFee))} BTC
        </span>
      </InfoBox>
      {/*)}*/}
      <InfoBox>
        <span className={'label'}>You will pay:</span>
        <span className={'value'}>
          <BtcIcon right={13} top={3} /> {formatFloat(formatSat(payAmount))} BTC
        </span>
      </InfoBox>
      <InfoBox>
        <span className={'label'}>Bitcoin Network Fee:</span>
        <span className={'value'}></span>
      </InfoBox>
      {!showTxLoading && <FeeSelector onChange={setFee} />}
      <Total>
        <span className={'label'}>Total</span>
        <span className={'value'}>
          <BtcIcon size={15} style={{ marginRight: 16 }} />
          {formatFloat(formatSat(takerFee + payAmount + networkFee))}
          <span>BTC</span>
        </span>
      </Total>
      {showConnect && <StyledButton onClick={active}>Connect Wallet</StyledButton>}
      {showBuy && (
        <StyledButton
          isLoading={loading > BuyLoadingStage.NotStart}
          onClick={async () => {
            const result = await buyPsbt()

            if (result) {
              if (props.onBuyed) {
                props.onBuyed()
              } else {
                location.reload()
              }
            }
          }}
        >
          {prepared ? 'Sign Setup Your Transaction To The Mempool' : 'Buy now'}
        </StyledButton>
      )}
      {showTxLoading && (
        <LoadingText>
          <Loading size={24} style={{ marginRight: 16 }} />
          Check the transaction here:&nbsp;
          <TxHashLink style={{ color: '#F5D802' }} txid={loadingHash} shorten={10} />
        </LoadingText>
      )}
    </SalePanelWrapper>
  )
}

const SalePanelWrapper = styled.div`
  width: 720px;
  padding-top: 30px;
  padding-left: 40px;
  padding-right: 75px;
  padding-bottom: 56px;
  position: relative;
  background: #1a1a1a;
  min-height: 325px;
`

const Total = styled.div`
  height: 24px;
  ${commonStyles.flexBetween};
  margin-top: 30px;
  span.label {
    font-size: 12px;
    color: #9e9e9e;
  }
  span.value {
    font-size: 24px;
    color: #efefef;
    span {
      font-size: 18px;
      margin-left: 8px;
    }
  }
`

const InfoBox = styled.div`
  height: 20px;
  ${commonStyles.flexBetween};
  margin-top: 15px;
  &:first-child {
    margin-top: 19px;
  }
  span.label {
    font-size: 12px;
    color: #9e9e9e;
  }
  span.value {
    font-size: 18px;
    color: #efefef;
  }
`

const StyledButton = styled(XButton)`
  //width: 602px;
  width: 100%;
  margin-top: 30px;
`

const LoadingText = styled.p`
  margin-top: 29px;
  line-height: 24px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  ${commonStyles.flexCenter}
`
